import { Image } from '@belong/ui';

type ImageSliceProps = {
  primary: {
    width: number;
    image: {
      url: string;
      alt: string;
      dimensions?: {
        width: number;
        height: number;
      };
    };
  };
};

export function ImageSlice({ primary }: ImageSliceProps) {
  const url = primary.image.url;
  const alt = primary.image.alt;
  const width = primary.width || '100%';
  const height = '100%';

  if (!url) return <></>;

  return (
    <div className="my-sm" style={{ width, height }}>
      <Image
        className="object-contain"
        src={url}
        alt={alt}
        width={width}
        height={height}
      />
    </div>
  );
}
